<template>
  <div class="footer-wrap">
    <div class="title">
      <div>
        <img src="../../assets/images//gaming/icon-shuoming.png" alt="">
        <span>图例说明:</span>
      </div>
    </div>
    <div class="img-list">
      <div class="img-item">
        <img src="../../assets//images/gaming/first_blood-pre.png" alt="">
        <span>一血</span>
      </div>
      <div class="img-item">
        <img src="../../assets//images/gaming/first_tower-pre.png" alt="">
        <span>一塔</span>
      </div>
      <div class="img-item">
        <img src="../../assets//images/gaming/five_kills-pre.png" alt="">
        <span>先五杀</span>
      </div>
      <div class="img-item">
        <img src="../../assets//images/gaming/ten_kills-pre.png" alt="">
        <span>先十杀</span>
      </div>
      <div class="img-item">
        <img src="../../assets//images/gaming/first_small_dragon-pre.png" alt="">
        <span>首小龙/首暴君</span>
      </div>
      <div class="img-item">
        <img src="../../assets//images/gaming/first_success-pre.png" alt="">
        <span>第一局获胜</span>
      </div>
      <div class="img-item">
        <img src="../../assets//images/gaming/16_success-pre.png" alt="">
        <span>第十六局</span>
      </div>
      <div class="img-item">
        <img src="../../assets//images/gaming/five_success-pre.png" alt="">
        <span>首五胜</span>
      </div>
      <div class="img-item">
        <img src="../../assets//images/gaming/ten_success-pre.png" alt="">
        <span>首十胜</span>
      </div>
      <div class="img-item">
        <img src="../../assets//images/gaming/first_big_dragon-pre.png" alt="">
        <span>首大龙/首主宰</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GamingFooter",
  data () {
    return {}
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.footer-wrap {
  display: flex;
  margin-top: 50px;
  padding-bottom: 30px;
  gap: 30px;
  .title {
    font-size: 16px;
    width: 130px;
    line-height: 32px;
    div {
      display: flex;
      align-items: center;
    }
    img {
      width: 24px;
      height: 24px;
      margin-right: 5px;
    }
  }
  .img-list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .img-item {
      display: flex;
      align-items: center;
      gap: 10px;
      width: 20%;
      img {
        width: 32px;
        height: 32px;
      }
      span {
        font-size: 16px;
      }
    }
  }
}
</style>
